import { gql } from '@apollo/client';

export default gql`
  query identityGetEuropeanVatInformation($country: String!, $number: String!) {
    identityGetEuropeanVatInformation(country: $country, vatNumber: $number) {
      __typename
      ... on VatInformation {
        countryCode
        vatNumber
        requestDate
        valid
        name
        address
      }
      ... on ServiceUnavailableError {
        reason
      }
      ... on InvalidInputError {
        reason
      }
      ... on MissedParametersError {
        reason
      }
      ... on ParseValidationResponseError {
        reason
      }
    }
  }
`;
